
import { useState } from 'react';
import secureLocalStorage from 'react-secure-storage'

export default function useToken() {
  
  const getToken = () => {
    const tokenString = secureLocalStorage.getItem('token');
    //console.log(tokenString)
    return (tokenString);
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    console.log("Save Token: " + userToken);
    secureLocalStorage.setItem('token', (userToken));
    setToken(userToken);
  };

  return {
    token,
    setToken: saveToken
  }
}